import React from 'react';

function About() {
    return (
        <div>
            <div className="banner-area banner-bg-1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="banner">
                                <h2>About us</h2>
                                {/* <ul className="page-title-link">
                                    <li><a href="#">Home</a></li>
                                    <li><a href="#">About</a></li>
                                </ul> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="about" className="section wb">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="message-box">
                                {/* <h4>About Us</h4> */}
                                {/* <h2>Welcome to My Piggycoins</h2> */}
                                {/* <div className="header" style={{ 'text-align': 'center' }}>
                                    <img src="images/logos/enin.jpg" alt="Logo" className="logo" />
                                </div> */}
                                {/* <p className="lead" style={{ color: 'black' }}>To outdo, the SME and large firms worldwide, besides technology, need competitive advantages.</p> */}

                                <p className="lead" style={{ color: 'black' }}>To outdo, you will need technology for competitive advantages and deliver more for less. eNin does it for you seamlessly.</p>

                                <p style={{ color: 'black' }}> Design / re-design is a passe - its the intervention, unto an additive or a contrary effect, that delivers the edge and finesse to the digital persona. </p>

                                <p style={{ color: 'black' }}> A combination of foresight, technology, learnings is one recipe but not impactful without a nudge .</p>

                                <p style={{ color: 'black' }}> Our eNin mobility products, SAAS platform, white-labeled solutions and its underlying framework orchestrate the operating model of different types of firms in unstructured outbound or out-of-office activities that almost every business is engaged in.</p>

                                <p style={{ color: 'black' }}> With this companies move forward quickly to bring timely interventions and realize value on a continuum of change.</p>

                                <p style={{ color: 'black' }}> We have extensive experience in</p>
                                <ul>
                                    <li style={{ color: 'black' }}>
                                        - delivering complex Transaction Design, Structuring, Modeling, Acquisition & Integration across multi-company enterprise, customers, consumers & banking partners.
                                    </li>
                                    <li style={{ color: 'black' }}>
                                        - in designing & implementing solutions on open source technologies, AWS and integration with widely used ERP such as Tally, SAP etc.
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="post-media wow fadeIn">
                                <img src="uploads/about_01.jpg" alt="" className="img-responsive img-rounded" />
                                {/* <a href="http://www.youtube.com/watch?v=nrJtHemSPW4" data-rel="prettyPhoto[gal]" className="playbutton"><i className="flaticon-play-button"></i></a> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;